import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { Restricted } from '../../../components/UI/Restricted.component';
import { SidebarNavigation } from '../../../components/Dashboard/account/SidebarNavigation/SidebarNavigation.component';
import { EditInformationForm } from '../../../components/Dashboard/account/EditInformationForm.component';
import { UserCard } from '../../../components/Dashboard/account/UserCard/UserCard.component';
import { StatusSwitch } from '../../../components/Dashboard/account/StatusSwitch/StatusSwitch.component';
import { Privileges } from '../../../components/Dashboard/account/Privileges.component';
import { AccessTable } from '../../../components/Dashboard/account/AccessTable.component';
import { DeleteUser } from '../../../components/Dashboard/account/DeleteUser.component';

import { Row, Col, Typography } from 'antd';
import '../AccountScreen/AccountScreen.css';

const { Title } = Typography;

export const EditUserAccountScreen = () => {

    const location    = useLocation();
    const account     = location.state;
    const {locations, Accesses} = account;
    const [isLoaded, setIsLoaded] = useState(false)
    const [accesses, setAccesses] = useState([])
    const [currentUser, setCurrentUser] = useState(account);

    useEffect(() => {
        Accesses.forEach(access => {
            setAccesses(accesses => [...accesses, access.accessUsername]);
        });  
        
        setIsLoaded(true)
    }, [])

    return(
        <>
            <div className="account-screen layout">
                <div className="account__sidebar">
                    <Col style={{ marginTop: "50px", marginBottom: "20px" }}>
                        <UserCard account={currentUser} />
                        {/* <SidebarNavigation description=""/> */}
                    </Col>
                </div>
                <div className="account__content">
                    <Row align="center">
                        <Col xs={20} sm={20} md={16} lg={16} xl={16}>
                            <Row align="end" className="row--align-center" style={{marginBottom: "20px"}}>
                                {/* <StatusSwitch/> */}
                            </Row>
                            <Title>User Information</Title>
                            { isLoaded && <EditInformationForm account={currentUser} setCurrentUser={setCurrentUser} isAdmin={true} location={location} locations={locations} accesses={accesses} />}
                            <Restricted to='accessManagement.deleteTech'>
                                <DeleteUser user={account}/>
                            </Restricted>
                        </Col>
                    </Row>
                </div>
            </div>                  
        </>
    )
};
